import React, { useState } from 'react';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import FormDialog from '../../../components/ui/FormDialog';
import { notify } from '../../../components/feedback/notify';

export default function MotivoCancelamentoNfse(props) {

    const [reason, setReason] = useState('');

    const handleClose = () => {
        setReason('');
        props.setOpenModalMotivoCancelamento(false);
    };

    const handleSubmit = () => {
        if (!reason.trim()) {
            notify.warning('Por favor, insira o motivo do cancelamento.');
            return;
        }

        props.handleCancelNfse(props.idNota, reason);
        handleClose();
    };

    return (
        <FormDialog
            open={props.openModalMotivoCancelamento}
            onClose={handleClose}
            onSubmit={handleSubmit}
            title={`Cancelar nota${props.idNota ? ` #${props.idNota}` : ''}`}
            description="Informe o motivo do cancelamento. Ele será registrado junto com a solicitação."
            submitLabel="Cancelar nota"
            cancelLabel="Voltar"
            submitColor="error"
            maxWidth="xs"
            disableBackdropClose
        >
            <Alert severity="warning" variant="outlined">
                O cancelamento não pode ser desfeito.
            </Alert>
            <TextField
                autoFocus
                required
                id="motivo"
                name="motivo"
                label="Motivo do cancelamento"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                fullWidth
                multiline
                minRows={3}
                size="small"
            />
        </FormDialog>
    );
}
